import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaUserTie, FaTools } from "react-icons/fa"
import adminLogo from "../../images/launch_axcell.png"
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { IoChatbubbles } from "react-icons/io5";
import { SiOpenaccess } from "react-icons/si";
import { MdWorkHistory, MdOutlineSupportAgent, MdDashboard, MdPerson, MdInfo, MdGavel, MdDomain, MdWork, MdPolicy } from 'react-icons/md'; // Importing icons from react-icons

const Sidenav = ({ isOpen , admin}) => {
  const location = useLocation(); // Identifying the current route for the active state

 

  return (
    <aside
      className={`overflow-y-auto  bg-gray-800 text-white scrollbar-hidden w-64 h-screen p-4 fixed top-0 left-0 transition-transform  transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
    >
      <div className=' h-20 w-30 mb-8 flex justify-center items-start'>
        <img className='h-20 w-30'
          src={adminLogo}
          alt='Admin Logo'
        />
      </div>
      <ul className="space-y-4">
        {/* Dashboard Link */}
        <li>
          <Link
            to="/"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdDashboard className="text-xl mr-3" /> {/* Dashboard Icon */}
            <span>Dashboard</span>
          </Link>
        </li>

        {/* Profile Link */}
        <li>
          <Link
            to="/profile"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/profile' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdPerson className="text-xl mr-3" /> {/* Profile Icon */}
            <span>Profile</span>
          </Link>
        </li>



        {/* Sub Contractor Link */}
        {admin.role === 'Contractor' ? (
        <li>
          <Link
            to="/support-staff"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/support-staff' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <FaUserTie className="text-xl mr-3" /> 
            <span>Support Staff</span>
          </Link>
        </li>) : (
            <div></div>
        )}

        {/* Domain Link */}
        {/* <li>
          <Link
            to="/domain"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/domain' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdDomain className="text-xl mr-3" /> {/* Domain Icon */}
            {/* <span>Domains</span>
          </Link>
        </li> */} 


        {/* Equipments Link */}
        <li>
          <Link
            to="/equipments"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/equipments' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <FaTools className="text-xl mr-3" /> {/* Privacy Policy Icon */}
            <span>Equipments</span>
          </Link>
        </li>

        {/* Sub Contractor Link */}
        <li>
          <Link
            to="/subcontractor"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/subcontractor' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <FaUserTie className="text-xl mr-3" /> 
            <span>Sub Contractors</span>
          </Link>
        </li>


         {/* Authorize Link */}
         <li>
          <Link
            to="/authorize-access"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/authorize-access' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <SiOpenaccess className="text-xl mr-3" /> 
            <span>Authorize/De-Authorize </span>
          </Link>
        </li>

        {/* Projects Link */}
        <li>
          <Link
            to="/projects"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/projects' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdWork className="text-xl mr-3" /> {/* Projects Icon */}
            <span>Projects Management</span>
          </Link>

        </li>
        {/* Assigned Projects Link */}
        <li>
          <Link
            to="/assigned-project"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/assigned-project' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdWorkHistory className="text-xl mr-3" /> {/* Projects Icon */}
            <span> Task Management</span>
          </Link>
        </li>


        {/* Invoice Link */}
        <li>
          <Link
            to="/invoice"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/invoice' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <LiaFileInvoiceSolid className="text-xl mr-3" /> {/* Domain Icon */}
            <span>Invoice Management</span>
          </Link>
        </li>


       {/* Chat Link */}
       <li>
          <Link
            to="/chat"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/chat' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <IoChatbubbles className="text-xl mr-3" /> 
            <span>Chat Support</span>
          </Link>
        </li>       


        {/* Query Link */}
        <li>
          <Link
            to="/query"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/query' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdOutlineSupportAgent className="text-xl mr-3" /> {/* Query Icon */}
            <span>Query Support</span>
          </Link>
        </li>

        {/* About Us Link */}
        <li>
          <Link
            to="/about-us"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/about-us' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdInfo className="text-xl mr-3" /> {/* About Us Icon */}
            <span>About Us</span>
          </Link>
        </li>

        {/* Terms and Conditions Link */}
        <li>
          <Link
            to="/terms"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/terms' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdGavel className="text-xl mr-3" /> {/* Terms Icon */}
            <span>Terms & Conditions</span>
          </Link>
        </li>

        {/* Privacy Policy Link */}
        <li>
          <Link
            to="/privacy-policy"
            className={`flex items-center p-2 rounded-md transition-colors ${location.pathname === '/privacy-policy' ? 'bg-blue-600' : 'hover:bg-gray-700'
              }`}
          >
            <MdPolicy className="text-xl mr-3" /> {/* Privacy Policy Icon */}
            <span>Privacy Policy</span>
          </Link>
        </li>
       


      </ul>
    </aside>
  );
};

export default Sidenav;
